var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Tạo mã QR code",
            visible: _vm.showCreateQRCodeDialog,
            width: "800px",
            "before-close": _vm.closeDialog,
            "close-on-click-modal": false,
            top: "10vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showCreateQRCodeDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-row",
                { attrs: { type: "flex", gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          size: "medium",
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          format: "dd-MM-yyyy",
                          placeholder: "Chọn ngày",
                          clearable: false,
                        },
                        model: {
                          value: _vm.dataInput.date,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataInput, "date", $$v)
                          },
                          expression: "dataInput.date",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            size: "medium",
                            placeholder: "Chọn trường",
                            filterable: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.dataInput.idSchool,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataInput, "idSchool", $$v)
                            },
                            expression: "dataInput.idSchool",
                          },
                        },
                        _vm._l(_vm.schoolList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: item.id + " - " + item.schoolName,
                              value: item.id,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("div", { staticStyle: { "margin-bottom": "6px" } }, [
                        _vm._v("Cố định"),
                      ]),
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.dataInput.fixed,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataInput, "fixed", $$v)
                            },
                            expression: "dataInput.fixed",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v("Có"),
                          ]),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v("Không"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { staticStyle: { "margin-top": "20px" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 2 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            size: "small",
                            loading: _vm.buttonLoading,
                            type: "primary",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.createQrCodeForOneAdminManual()
                            },
                          },
                        },
                        [_vm._v("Tạo QR code\n          ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }